const Operator = {
	Equal: 1,
	Like: 2,
}
export default Operator;